<template>
    <div class="mt-4">
        <div class="disclaimer-panel">
            <div class="d-flex">
                <v-textarea
                    v-model="model.text"
                    class="disclaimer-field"
                    color="black"
                    solo
                    auto-grow
                    full-width
                    rows="2"
                    row-height="10"
                    dense
                    filled
                    :maxlength="maxDisclaimerTextLength"
                    :value="model.text"
                    @change="setDisclaimerAttribute('text')"
                />
            </div>
            <div class="d-flex">
                <v-spacer/>

                <div class="align-self-baseline">
                    <div class="font-size-select">
                        <v-select
                            class="pa-0"
                            v-model="model.fontsize"
                            solo
                            :height="30"
                            :items="fontSizeItems"
                            @input="setDisclaimerAttribute('fontsize')"
                        />
                    </div>
                </div>

                <v-spacer/>

                <div class="align-self-baseline">
                    <v-menu
                        offset-y
                        :close-on-content-click="false"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="color-picker-cta"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                :elevation="0"
                                :style="{'background-color': model.color }"
                            />
                        </template>
                        <v-list class="py-0">
                            <v-list-item class="px-0">
                                <v-list-item-content class="py-0">
                                    <v-color-picker
                                        v-model="model.color"
                                        dot-size="25"
                                        hide-inputs
                                        swatches-max-height="200"
                                        @input="setDisclaimerAttribute('color')"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>

                <v-spacer/>
            </div>
        </div>
        
        <StepSaveByDefaultCheckbox
            class='mt-2'
            :selectedOption="model"
            :stepId="'disclaimer'"
            :label="$t('habiteoStudio.saveByDefault')"
        />  
    </div>
</template>

<script>
    import StepSaveByDefaultCheckbox from '@/components/myHabiteoStudio/steps/components/StepSaveByDefaultCheckbox';

    export default {
        name: 'DisclaimerPanel',
        components: {
            StepSaveByDefaultCheckbox
        },
        props: {
            selectedValues: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                fontSizeItems: [
                    {
                        text: this.$t('habiteoStudio.fontSize.small'),
                        value: 12
                    },
                    {
                        text: this.$t('habiteoStudio.fontSize.medium'),
                        value: 16
                    },
                    {
                        text: this.$t('habiteoStudio.fontSize.tall'),
                        value: 24
                    }
                ],
                model: {},
                isSettingsUpdated: false,
                maxDisclaimerTextLength: 74
            }
        },
        created() {
            this.model = this.$props.selectedValues;
        },
        methods: {
            setDisclaimerAttribute(type) {
                var value = this.model[type] || '';
                this.$emit(`set-${type}`, value);
                this.isSettingsUpdated = false;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/DisclaimerPanel.vue